import styles from './banner.module.scss'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Banner1 from '/public/images/gb.png'
import { Input } from 'antd';
import { useState }  from "react";
import { ssoLogin } from "@/service/index";
import icon from '/public/images/google.png'
import { useWidth } from '@/utils/resize'
import buriedSdk from '@/utils/zz-buried/index'
type Props = {}

const Index = (props: Props) => {
  const [email , setEmail] = useState('')
  const [close , setClose] = useState(false)
  const { width, display } = useWidth()
  const { t, i18n } = useTranslation('home')
  console.log(i18n)
  const handleGoogle = async () => {
    const res = await ssoLogin()
      console.log("ssoLogin~~", res);
      if (res?.code === 0) {
        window.location.href = res.data;
      }
  }
  const handleOnChangeInput = (e) => {
    setEmail(e.target?.value)
  }
  const handleToLogin = () => {
    buriedSdk.buried({
      event: `按钮点击`,
      scene: `文章详情页--Start Free Trial注册按钮`,
      URL: window.location.href
    })
    const emailCheck = email ? '?email='+email : ''
    window.open(
      process.env.portalApiUrl + '/login' + emailCheck,
    )
  }
  const handleMobileClose = () => {
    setClose(true)
  }
  return (
    <div
      className={`${styles.loginFree} ${close ? 'hidden': '' }`}

    >
       <span className={styles.mobileClose} onClick={handleMobileClose}>
                  <svg
                    className="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2243"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M283.456 223.338667l2.709333 2.496L512 451.626667l225.834667-225.813334a42.666667 42.666667 0 0 1 62.826666 57.621334l-2.496 2.709333L572.373333 512l225.813334 225.834667a42.666667 42.666667 0 0 1-57.621334 62.826666l-2.709333-2.496L512 572.373333 286.165333 798.165333a42.666667 42.666667 0 0 1-62.826666-57.621333l2.496-2.709333L451.626667 512 225.834667 286.165333a42.666667 42.666667 0 0 1 57.621333-62.826666z"
                      p-id="2244"
                      fill="#2E384E"
                    ></path>
                  </svg>
                </span>
    <h3 className="text-[#000]">{t("Start your TikTok shop's sales quickly.")}<span className="text-[#FF3E5F] ml-[4px]">{t("For free")}</span>  </h3>
    <Input onChange={handleOnChangeInput} className={styles.inputBox} placeholder={t('Enter your email address')}></Input>
    <div className={styles.Btna} onClick={handleToLogin}>{t('Start Free Trial')}</div>
    <div
            className={` cursor-pointer text-center flex items-center justify-center py-14px px-21px !bg w-[100%] h-48px ${styles.google}`}
            onClick={handleGoogle}
          >
           <Image
               width={24}
               height={24}
                className={`${styles.icon}`}
                alt={ t("Sign in with Google")}
                src={icon}
              ></Image>

            <span className='ml-[4px]'>{ t("Sign Up/Sign in with Google") }</span>
          </div>
    </div>
  )
}
export default Index
